import store from '@/store'

/** 权限指令**/
export const removeAuth = {
  mounted(el: any, binding: any) {
    let btnPermissions = binding.value
    let btnflag = false

    store.state.adminInfo.menuAuthChildren.forEach((item: any) => {
      if (item === btnPermissions) {
        btnflag = true
      }
    })
    if (!btnflag) {
      el.parentNode.removeChild(el)
    }
  }
};
/**
 * 权限验证 v-auth
 * btnAuth：false 置灰 true 隐藏
 */
export const auth = {
  mounted(el: any, binding: any) {
    let btnPermissions = binding.value
    let btnflag = false
    store.state.adminInfo.menuAuthChildren.forEach((item: any) => {
      if (item === btnPermissions) {
        btnflag = true
      }
    })

    if (!btnflag) {
      if (store.state.systemSet.btnAuth) el.parentNode.removeChild(el);
      else {
        const isdisabled = el.getAttribute('class') + " is-disabled"
        console.log(isdisabled)
        console.log(el.firstElementChild)
        el.setAttribute("class", isdisabled)
        el.setAttribute("disabled", "");
      }
    }
  }
};
